import React from 'react';
import { useNavigate } from 'react-router-dom';

const members = [
  { initial: 'S', name: 'saifalikhan-98', email: 'salikhan329@gmail.com', role: 'Owner', you: true, gradient: 'linear-gradient(135deg,#6366f1,#a855f7)' },
  { initial: 'A', name: 'ali-dev', email: 'ali@bravionltd.com', role: 'Admin', you: false, gradient: 'linear-gradient(135deg,#0ea5e9,#06b6d4)' },
  { initial: 'N', name: 'nadia-qa', email: 'nadia@bravionltd.com', role: 'Viewer', you: false, gradient: 'linear-gradient(135deg,#f59e0b,#f97316)' },
];

const permissions: [string, boolean, boolean, boolean, boolean][] = [
  ['View deployments & logs', true, true, true, true],
  ['Deploy new applications', false, true, true, true],
  ['Delete deployments', false, false, true, true],
  ['Manage cloud accounts', false, false, true, true],
  ['Billing & plan management', false, false, false, true],
];

export const TeamRBACView: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: '#09090e', minHeight: '100vh', fontFamily: "'Inter',sans-serif" }}>
      {/* Topbar */}
      <div style={{ height: '50px', background: '#111116', borderBottom: '1px solid #26262f', display: 'flex', alignItems: 'center', padding: '0 20px', position: 'sticky' as const, top: 0, zIndex: 50 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12.5px', color: '#8e8ea8' }}>
          <span>Home</span><span style={{ color: '#52525f' }}>›</span>
          <span style={{ color: '#eeeef5', fontWeight: 500 }}>Team & RBAC</span>
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <button style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px', borderRadius: '6px', fontSize: '12.5px', fontWeight: 500, cursor: 'not-allowed', border: 'none', background: '#3d3f6b', color: '#818cf8', opacity: 0.5 }}>
            + Invite Member
          </button>
        </div>
      </div>

      <div style={{ padding: '20px 24px' }}>
        <div style={{ marginBottom: '20px' }}>
          <h1 style={{ fontFamily: "'Syne',sans-serif", fontSize: '20px', fontWeight: 700, color: '#eeeef5', marginBottom: '3px' }}>Team & Access Control</h1>
          <p style={{ fontSize: '13px', color: '#8e8ea8' }}>Manage who can view, deploy, and administer your workspace</p>
        </div>

        {/* Upgrade callout */}
        <div style={{
          background: 'linear-gradient(135deg,rgba(99,102,241,.08),rgba(168,85,247,.08))',
          border: '1px solid rgba(99,102,241,.22)', borderRadius: '6px',
          padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '7px',
          fontSize: '12px', color: '#818cf8', marginBottom: '20px',
        }}>
          🔒 Team management & RBAC requires the{' '}
          <strong style={{ color: '#eeeef5' }}>Pro plan</strong>. Upgrade to invite teammates and control access.
          <button
            onClick={() => navigate('/plans')}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '4px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: 500, cursor: 'pointer', border: 'none', background: '#6366f1', color: '#fff', marginLeft: 'auto' }}
          >
            Upgrade Now
          </button>
        </div>

        {/* Dimmed content */}
        <div style={{ opacity: 0.45, pointerEvents: 'none' as const }}>

          {/* Team members card */}
          <div style={{ background: '#111116', border: '1px solid #26262f', borderRadius: '10px', padding: '18px', marginBottom: '14px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
              <div style={{ fontSize: '13.5px', fontWeight: 600, color: '#eeeef5' }}>Team Members</div>
              <div style={{ fontSize: '12px', color: '#52525f' }}>3 of 5 seats used</div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {members.map(m => (
                <div key={m.name} style={{ background: '#17171e', border: '1px solid #26262f', borderRadius: '10px', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: m.gradient, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 700, color: '#fff', flexShrink: 0 }}>
                    {m.initial}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', fontWeight: 500, color: '#eeeef5' }}>
                      {m.name}{' '}
                      {m.you && <span style={{ fontSize: '10px', color: '#818cf8' }}>(you)</span>}
                    </div>
                    <div style={{ fontSize: '12px', color: '#52525f' }}>{m.email}</div>
                  </div>
                  <select
                    defaultValue={m.role}
                    style={{ background: '#17171e', border: '1px solid #26262f', borderRadius: '6px', padding: '4px 8px', fontSize: '12px', color: '#eeeef5', fontFamily: "'Inter',sans-serif", cursor: 'pointer', outline: 'none' }}
                  >
                    {['Owner', 'Admin', 'Developer', 'Viewer'].map(r => <option key={r}>{r}</option>)}
                  </select>
                  {!m.you && (
                    <div style={{ width: '26px', height: '26px', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#52525f' }}>
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M2 3h8M4.5 3V2h3v1M5 5.5v4M7 5.5v4M2.5 3l.6 7h5.8l.6-7"/>
                      </svg>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Role permissions table */}
          <div style={{ background: '#111116', border: '1px solid #26262f', borderRadius: '10px', padding: '18px' }}>
            <div style={{ fontSize: '13.5px', fontWeight: 600, color: '#eeeef5', marginBottom: '14px' }}>Role Permissions</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12.5px' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #26262f' }}>
                  {['Permission', 'Viewer', 'Developer', 'Admin', 'Owner'].map(h => (
                    <th key={h} style={{ padding: '8px 12px', fontWeight: 600, textAlign: h === 'Permission' ? 'left' : 'center', color: '#52525f', fontSize: '10.5px', textTransform: 'uppercase' as const, letterSpacing: '.06em' }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {permissions.map((row, i) => (
                  <tr key={row[0]} style={{ borderBottom: i < permissions.length - 1 ? '1px solid #26262f' : 'none' }}>
                    <td style={{ padding: '10px 12px', color: '#8e8ea8' }}>{row[0]}</td>
                    {[row[1], row[2], row[3], row[4]].map((val, j) => (
                      <td key={j} style={{ padding: '10px 12px', textAlign: 'center' as const }}>
                        {val ? '✅' : <span style={{ color: '#52525f' }}>—</span>}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamRBACView;